import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Carrier, Code, Rating } from 'src/app/model/carrier';
import { EntityType } from 'src/app/model/entity-types';
import { Filter } from 'src/app/model/search';
import { StorageKeys } from 'src/app/model/storage-keys';
import { GroupFilterFieldName } from 'src/app/model/uiOptions';
import { OptionsService } from 'src/app/services/options.service';
import { StateService } from 'src/app/services/state.service';
import { transformCodes } from 'src/app/shared/transformCodes'
@Component({
    selector: 'detail-summary',
    templateUrl: './detail-summary.component.html',
    styleUrls: ['./detail-summary.component.css'],
    standalone: false
})
export class DetailSummaryComponent {
  @Input() details: Carrier | any = [];
  @Input() codes: Code[] = [];
  @Input() ratings: Rating[] = [];
  @Input() entityType!: EntityType;
  entityTypeEnum= EntityType;

  constructor(private stateService: StateService, private router:Router) { 
  }

  goToLink(url: string) {
    window.open('http://' + url, '_blank');
  }
  transform(codeName:string):string{
   return transformCodes(codeName);
  }

  goToGroupDetails() {
    if(this.details?.groupName){ 
      this.stateService.clearItem(StorageKeys.Filters);
      this.stateService.clearItem(StorageKeys.SearchTerm);
      this.stateService.clearItem(StorageKeys.PageNumber);
      this.stateService.clearItem(StorageKeys.PageSize);
      this.stateService.setState(StorageKeys.Filters, [{ ...this.buildFilter() }]);
      this.router.navigate(['/search']);
    }
  }

  buildFilter(){
    const filter = <Filter>{
     fieldName: GroupFilterFieldName,
     expression:  '=',
     selectedField: {key: "GroupName", value: "Group"},
     type: 'group',
     value: this.details?.groupName
    }
    return filter;
  }
}